export const DateRangePickerTestHandlers = {
  wrapper: 'date-range-picker',
  daysCount: 'date-range-picker-days-count',
  previewRange: 'date-range-picker-preview-range',
  okButton: 'date-range-ok-button',
};
